module.exports = __webpack_public_path__ + "static/media/icon_sider.2868bd97.png";